export default {
  // Errors
  notFound: 'Province not found',

  //Words
  enterProvince: 'Enter province',
  province: 'Province'
}